<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-top">
        <router-link to="/" class="footer-logo-link">
          <img :src="logoUrl" alt="Gemeinschaft Freier Wähler Laatzen" class="footer-logo" />
        </router-link>

        <nav class="footer-nav">
          <router-link to="/">Start</router-link>
          <router-link to="/ziele">Ziele</router-link>
          <router-link to="/mitglieder">Mitglieder</router-link>
          <router-link to="/themen">Themen</router-link>
          <router-link to="/mitgestalten">Idee einreichen</router-link>
          <router-link to="/neuigkeiten">Neuigkeiten</router-link>
          <router-link to="/ueber-uns">Über uns</router-link>
        </nav>
      </div>

      <div class="footer-bottom">
        <div class="footer-info">
          <p>Gemeinschaft Freier Wähler Laatzen &copy; {{ currentYear }}</p>
          <div class="footer-legal">
            <router-link to="/impressum">Impressum</router-link>
            <span class="legal-dot">·</span>
            <router-link to="/datenschutz">Datenschutz</router-link>
            <span class="legal-dot">·</span>
            <router-link to="/transparenz">Transparenzbekanntmachung</router-link>
          </div>
        </div>

<!--        <div class="footer-social">-->
<!--          <a-->
<!--              href="https://instagram.com/freiewaehler_laatzen"-->
<!--              target="_blank"-->
<!--              rel="noopener noreferrer"-->
<!--              class="social-link"-->
<!--              aria-label="Instagram"-->
<!--          >-->
<!--            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">-->
<!--              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>-->
<!--              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>-->
<!--              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>-->
<!--            </svg>-->
<!--            <span>@freiewaehler_laatzen</span>-->
<!--          </a>-->
<!--        </div>-->
      </div>

      <p class="footer-credit">
        Erstellt mit
        <i class="mdi mdi-heart" style="color: #FA6A01;"></i>
        von
        <a href="https://zirke-digital.de" target="_blank" rel="noopener noreferrer">zirke-digital</a>
      </p>
    </div>
  </footer>
</template>

<script>
import logoUrl from '@/assets/gfw_logo.png'

export default {
  name: 'AppFooter',
  data() {
    return {
      logoUrl,
      currentYear: new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.site-footer {
  background: #00265E;
  color: white;
  padding: 48px 32px 32px;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 40px;
  padding-bottom: 36px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  margin-bottom: 28px;
}

.footer-logo-link {
  flex-shrink: 0;
}

.footer-logo {
  height: 48px;
  width: auto;
  display: block;
}

.footer-nav {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
}

.footer-nav a {
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  transition: color 0.2s ease;
}

.footer-nav a:hover {
  color: #FA6A01;
}

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
}

.footer-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.footer-info p {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.85rem;
  margin: 0;
}

.footer-legal {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 6px;
  gap: 8px;
}

.footer-legal a {
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  font-size: 0.85rem;
  transition: color 0.2s ease;
}

.footer-legal a:hover {
  color: #FA6A01;
}

.legal-dot {
  color: rgba(255, 255, 255, 0.3);
}

.social-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 100px;
  color: white;
  text-decoration: none;
  font-size: 0.85rem;
  font-weight: 500;
  transition: all 0.25s ease;
}

.social-link:hover {
  background: #FA6A01;
  border-color: #FA6A01;
  color: #00265E;
  transform: translateY(-2px);
}

.footer-credit {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  text-align: center;
  color: rgba(255, 255, 255, 0.35);
  font-size: 0.8rem;
}

.footer-credit a {
  color: rgba(255, 255, 255, 0.55);
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-credit a:hover {
  color: #FA6A01;
}

@media (max-width: 768px) {
  .footer-top {
    flex-direction: column;
    gap: 24px;
  }

  .footer-nav {
    gap: 16px;
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
  }

  .footer-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>